var map = {
	"./antd.svg": "LcLJ",
	"./aws.svg": "4qd1",
	"./bootstrap.svg": "G5FI",
	"./css3.svg": "1Et3",
	"./docker.svg": "j9Dk",
	"./elasticsearch.svg": "dqGJ",
	"./express.svg": "D6Qw",
	"./gatsby.svg": "N7h8",
	"./go.svg": "ijCW",
	"./graphql.svg": "i7ck",
	"./hasura.svg": "daW0",
	"./heroku.svg": "eIji",
	"./js.svg": "08kM",
	"./mongodb.svg": "LmU5",
	"./nodejs.svg": "RB9Y",
	"./postgresql.svg": "Nry7",
	"./pptr.svg": "Rz+j",
	"./python.svg": "wkFu",
	"./react.svg": "sZ2M",
	"./redis.svg": "UZJq",
	"./sass.svg": "HJHK",
	"./vuejs.svg": "Q5Yn",
	"./vuetify.svg": "s2Ii"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "OeMy";